import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/legal/consumidor/page.tsx");
